import { SectionListData } from '../type/sectionList';
import React, { useMemo } from 'react';
import {
  borderBottom as cardBorder,
  getConsentStatus,
} from '../screen/HouseholdDashboard/component/BottomCard/util';
import { getConsentStatusTranslation, getPersonFullName } from 'utils/util';
import { DxContainer, DxText } from '@dvag/design-system-react';
import { dashboardUtil } from 'service/model/dashboardUtil';
import { ConsentDto, PersonInHouseholdDto } from 'graphql/person/generates';
import { useParams } from 'react-router-dom';

const { PRIVACY_POLICY } = dashboardUtil;

export const useGdprData = (
  personList: PersonInHouseholdDto[],
  consentList: ConsentDto[] | undefined,
): SectionListData[] => {
  const { householdId } = useParams();

  return useMemo(
    () =>
      personList?.map((person, index) => {
        const consent = consentList?.find((data) => data?.personId === person.id);
        const consentStatus = getConsentStatus(consent?.status);
        const isLast = personList.length - 1 === index;

        return {
          householdId,
          id: `${person?.id}-gdpr`,
          gdprStatus: consentStatus,
          personId: person?.id,
          path: PRIVACY_POLICY,
          title: getPersonFullName(person),
          icon: 'mensch',
          borderBottom: !isLast ? cardBorder : 'none',
          renderRightSection: () => (
            <div data-testid={`consent-status-${index}`}>
              {consentStatus && (
                <div className="gdpr-status">
                  <DxText type="Infotext-Standard" color="gray-66" style={{ padding: 0 }}>
                    {getConsentStatusTranslation(consentStatus.descriptionKey)}
                  </DxText>
                  <DxContainer
                    color="white"
                    className="gdpr-icon flex row align-center justify-center"
                    style={{ color: '#337a96' }}
                  >
                    <consentStatus.Icon />
                  </DxContainer>
                </div>
              )}
            </div>
          ),
        };
      }),
    [consentList, householdId, personList],
  );
};
